<template>
  <el-time-picker
    class="e-time date"
    :name="name"
    v-model="model[name]"
    :format="format"
    :value-format="valueFormat"
    ref="calendar"
    v-bind:disabled="disabled"
    :pickerOptions="pickerOptions"
    :placeholder="getPlaceholder">
  </el-time-picker>
</template>

<script>
  export default {
    name: 'e-time',
    data () {
      return {
        error: null
      }
    },
    props: {
      formValidator: null,
      model: {
        type: Object,
        required: true
      },
      tabView: {
        type: String,
        default: null,
        required: true
      },
      name: {
        type: String,
        default: null,
        required: true
      },
      validateAlias: {
        type: String,
        default: null
      },
      validationRule: {
        type: String,
        default: 'string'
      },
      required: {
        type: Boolean,
        default: false
      },
      modalVariableName: {
        type: String,
        default: null
      },
      valueFormat: {
        type: String,
        default: 'HH:mm'
      },
      format: {
        type: String,
        default: 'HH:mm'
      },
      disabled: {
        type: Boolean,
        default: false
      },
      placeholder: {
        type: String,
        default: ''
      },
      pickerOptions: {
        type: Object,
        default: function () {
          return {}
        }
      }
    },
    computed: {
      hasError () {
        if (this.error) {
          return true
        }
        return false
      },
      getPlaceholder(){
        if(this.placeholder === null){
          return ''
        }
        return this.placeholder
      }
    },
    created () {
      if(this.formValidator){
        this.formValidator.subscribeInput(this)
      }
      this.initEventListeners()
    },
    destroyed () {
      if (this.subs) {
        this.subs.unsubscribe()
        this.subs = null
      }
    },
    methods: {
      initEventListeners () {
        this.subs = this.$emitter.listen('e-perfect-scrollbar', this.onScroll)
      },
      // @bugfix: on scroll doesnt update absolute picker position
      onScroll (data) {
        if (data && data.action && data.event && data.action === 'ps-scroll-y') {
          this.$refs.calendar.hidePicker()
        }
      },
      getElement(){
        return this.$refs.calendar
      },
      validate () {
        let msg = ''
        if (this.required) {
          if (typeof this.model[this.name] == 'undefined') {
            msg += 'Укажите время'
          } else if (this.model[this.name] === null) {
            msg += 'Укажите время'
          } else if (this.model[this.name].toString().length < 1) {
            msg += 'Укажите время'
          }
        }

        return {
          error: msg,
          tabView: this.tabView,
          name: this.name,
          modalVariableName: this.modalVariableName,
          el: this.getElement()
        }
      }
    }
  }
</script>
